import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import Resgiter from '@/components/resgiter/resgiter'
import Sindex from '@/components/sindex/sindex'
import Main from '@/components/main/main'
import User from '@/components/user/user'
import Product from '@/components/product/product'
import Product1 from '@/components/product/product1'

import Personal from '@/components/user/personal_user'
import Passuser from '@/components/user/password_user'
import Pushemail from '@/components/user/mail_tui'
import Boxnumber from '@/components/user/box_number'
import Casestatis from '@/components/user/case_statis'
import UserPay from '@/components/user/user_pay'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
     {
      path: '/',
      name: 'Sindex',
      component: Sindex
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main
    }, {
      path: '/Resgiter',
      name: 'Resgiter',
      component: Resgiter
    }, {
      path: '/Login',
      name: 'Login',
      component: Login
    }, {
      path: '/Product',
      name: 'Product',
      component: Product
    }, {
      path: '/Product1',
      name: 'Product1',
      component: Product1
    }, {
      path: '/User',
      name: 'User',
      component: User,
      children: [
        {
          path: '/Personal',
          name: 'Personal',
          component: Personal
        }, {
          path: '/Casestatis',
          name: 'Casestatis',
          component: Casestatis
        },{
          path: '/Passuser',
          name: 'Passuser',
          component: Passuser
        }, {
          path: '/Pushemail',
          name: 'Pushemail',
          component: Pushemail
        },{
          path: '/Boxnumber',
          name: 'Boxnumber',
          component: Boxnumber
        },{
          path: '/UserPay',
          name: 'UserPay',
          component: UserPay
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js